import React, {useEffect, useState} from 'react';
import {View, ScrollView} from 'react-native';
import _ from 'lodash';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {address as addressApi} from '~/api/public';
import {Dialog, FormTextInput, Text} from '~/components/controls';
import withDimensions from '~/components/hoc/with-dimensions';

const DIALOG_HEADER_IN_PIXELS = 65;
const DIALOG_FOOTER_IN_PIXELS = 51;

const doSearch = _.debounce(
  async (postalCode, houseNumber, annex, setAddress) => {
    const address = await addressApi.fetch(postalCode, houseNumber, annex);

    setAddress(address);
  },
  500,
);

const PickupLocationDialog = ({dimensions, visible, onDismiss, onOK}) => {
  const [postalCode, setPostalCode] = useState(null);
  const [houseNumber, setHouseNumber] = useState(null);
  const [annex, setAnnex] = useState(null);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    if (!visible) {
      setPostalCode(null);
      setHouseNumber(null);
      setAnnex(null);
      setAddress(null);
    }
  }, [visible]);

  useEffect(() => {
    if (postalCode?.length > 4 && houseNumber) {
      doSearch(postalCode, houseNumber, annex, setAddress);
    } else {
      setAddress(null);
    }
  });

  return (
    <Dialog
      visible={visible}
      title="Ophaallocatie"
      onDismiss={onDismiss}
      buttons={[
        {
          text: 'Annuleren',
          onPress: onDismiss,
        },
        {
          text: 'OK',
          disabled: !address,
          onPress: () =>
            onOK({
              postalCode,
              houseNumber,
              annex,
              ...address,
            }),
        },
      ]}>
      <ScrollView
        contentContainerStyle={{
          maxHeight:
            dimensions.window.height -
            DIALOG_HEADER_IN_PIXELS -
            DIALOG_FOOTER_IN_PIXELS,
        }}>
        <View style={[sy['py-4'], sy['gap-4']]}>
          <FormTextInput label="Postcode" onChangeText={setPostalCode} />
          <FormTextInput label="Huisnummer" onChangeText={setHouseNumber} />
          <FormTextInput label="Toevoeging" onChangeText={setAnnex} />
          {address && (
            <>
              <Divider />
              <View>
                <Text>
                  {address.street}&nbsp;{houseNumber}
                </Text>
                {annex && <Text>{annex}</Text>}
                <Text style={[sy.smallRegular, sy['text-lightgray']]}>
                  {postalCode}&nbsp;{address.city}
                </Text>
              </View>
            </>
          )}
        </View>
      </ScrollView>
    </Dialog>
  );
};

export default withDimensions(PickupLocationDialog);
